/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Sem_IdInputs */

const cs_sklik_sem_id = /** @type {(inputs: Sklik_Sem_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEM S2S ID`)
};

const en_sklik_sem_id = /** @type {(inputs: Sklik_Sem_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEM S2S ID`)
};

/**
* | output |
* | --- |
* | "SEM S2S ID" |
*
* @param {Sklik_Sem_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_sem_id = /** @type {((inputs?: Sklik_Sem_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Sem_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_sem_id(inputs)
	return cs_sklik_sem_id(inputs)
});